import type { IGuestLogin, IGuestLoginRequest } from "@/types"
import { axios } from "@/axios"

export async function loginGuest(login: IGuestLogin, eventVaultId?: number) {
  const loginRequest: IGuestLoginRequest = {
    Name: login.name,
    Email: login.email,
    AccessToken: login.accessToken,
    Passcode: login.passcode,
    EventAlbumID: login.eventAlbumID,
    MarketingOptIn: login.marketingOptIn,
  }

  const response = await axios.post(`api/guest/${eventVaultId}/login`, loginRequest)

  return response.data.Message
}
